export const itemPerPage = 20;

export const triageType = {
  CAT1: "CAT1",
  CAT2: "CAT2",
  CAT3: "CAT3",
  CAT4: "CAT4",
  CAT5: "CAT5",
};
